import { render, staticRenderFns } from "./FieldCores.vue?vue&type=template&id=174c07dd&"
import script from "./FieldCores.vue?vue&type=script&lang=js&"
export * from "./FieldCores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports